import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { AGENT_TYPE_ID, ARTIST_TYPE_ID, AOS_TYPE_ID } from '../../constants/consts';
import route from '../../constants/routes';
import { getRouteWithSlug } from '../../utils/common';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  profileType: {
    fontSize: 14,
    color: colors.text,
  },
  agentsBlock: {
    fontSize: 14,
    color: colors.text,
  },
  link: {
    display: 'inline-block',
    color: colors.blue,
  },
}));

const ProfileMenuItem = ({ profile, onProfileSelect }) => {
  const classes = useStyles();
  const profileType = get(profile, 'profileType.name', '');
  const profileTypeId = get(profile, 'profileType.id', '');
  const agencies = get(profile, profileTypeId === AGENT_TYPE_ID ? 'agencies' : 'companies', []);
  const artistProfession =
    get(profile, 'profession.qualification.name') || get(profile, 'profession.name') || get(profile, 'summary', '');

  return (
    <>
      <div className={classes.profileType}>{profileType}</div>

      <div className={classes.agentsBlock}>
        {profileTypeId === AGENT_TYPE_ID &&
          agencies.map((agency, index) => (
            <span key={`profileAgency-${get(agency, 'id')}`} className={classes.link}
              onClick={(e) => {
                e.stopPropagation();
                onProfileSelect(`${route.MANAGERS}/[id]`, getRouteWithSlug(route.MANAGERS, agency));
              }}>
              {get(agency, 'name')}

              {agencies.length > 1 && index !== agencies.length - 1 && ', '}
            </span>
          ))}
        {profileTypeId === ARTIST_TYPE_ID && (
          <span className={classes.link}
          onClick={(e) => {
            e.stopPropagation();
            onProfileSelect(`${route.ARTISTS}/[id]/[[...action]]`, getRouteWithSlug(route.ARTISTS, profile))
          }}>
            {get(profile, 'name')}
            {artistProfession && `, ${artistProfession}`}
          </span>
        )}
        {profileTypeId === AOS_TYPE_ID &&
          agencies.map((company, index) => (
            <span className={classes.link} key={`profileAgency-${get(company, 'company.id')}`}
            onClick={(e) => {
              e.stopPropagation();
              onProfileSelect(`${route.COMPANIES}/[country]/[id]/[[...action]]`, getRouteWithSlug(`${route.COMPANIES}/${get(company.company, 'country.slug')}`, company.company))
            }}
            >
              {get(company, 'company.name')}
              {agencies.length > 1 && index !== agencies.length - 1 && ', '}
            </span>
          ))}
      </div>
    </>
  );
};

ProfileMenuItem.propTypes = {
  profile: PropTypes.object,
  onProfileSelect: PropTypes.func,
};

export default memo(ProfileMenuItem);
